export default "__VITE_ASSET__B0mXQLNx__"